import axios from "axios";

export const fetchHomeBannerCategories = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_HOME_BANNER_CATEGORY_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getHomeBannerCategories`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_HOME_BANNER_CATEGORY_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_HOME_BANNER_CATEGORY_FAILURE",
      payload: error.message,
    });
  }
};
